<div class="SLV2-excrsprgrs-poparea">
    <div class="SLV2-excrsprgrs-hdr">
        <span>Exercise</span>
        <button class="SLV2-popup-close-btn" mat-dialog-close>
            <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" />
        </button>
    </div>

    <!-- design 4 start -->
    <ng-container *ngIf="true">
        <ng-container *ngTemplateOutlet="SLV2Attmpcunt"></ng-container>

        <div class="SLV2-progress-info-box white">
            <ng-container *ngTemplateOutlet="SLV2Accuracycunt"></ng-container>

            <div class="SLV2-progress-icon-holdr sm">
                <img src="selflearnv2-ui/assets/img/animation-champion-icon.gif" />
            </div>
            <div class="SLV2-progress-info-cntarea">
                <h3 class="SLV2-progress-greeting-hdng">Congrats!</h3>
                <p class="SLV2-progress-text">You have already cleared this exercise.</p>
                <p class="SLV2-progress-text">We recommend you to practice next topic.</p>
                <div class="SLV2-progress-actn-area">
                    <button class="SLV2-progress-solid-btn">Go to Next Topic</button>
                    <button class="SLV2-progress-text-btn">View solutions</button>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- design 4 closed -->


    <!-- design 6 / re-attampt start -->
    <ng-container *ngIf="false">
        <ng-container *ngTemplateOutlet="SLV2Attmpcunt"></ng-container>

        <div class="SLV2-progress-info-box white">
            <ng-container *ngTemplateOutlet="SLV2Accuracycunt"></ng-container>

            <div class="SLV2-progress-icon-holdr sm">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/sad-emoji-animated.gif" />
            </div>
            <div class="SLV2-progress-info-cntarea">
                <h3 class="SLV2-progress-greeting-hdng">Uh-uh!</h3>
                <p class="SLV2-progress-text">Score at least 80% to clear this exercise</p>
                <p class="SLV2-progress-text">Don’t worry. Together we will get there.</p>
                <div class="SLV2-progress-actn-area">
                    <button class="SLV2-progress-solid-btn">Re-attempt</button>
                    <button class="SLV2-progress-text-btn">View solutions</button>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- design  6 / re-attampt closed -->



</div>





<ng-template #SLV2Attmpcunt>
    <div class="SLV2-attmpcunt-section">
        <div class="SLV2-attmp-info"><img class="icon"
                src="selflearnv2-ui/assets/img/self-learn-v2/users-white-group.svg" /><span>808
                attempts</span></div>
        <div class="SLV2-attmp-info"><img class="icon white"
                src="selflearnv2-ui/assets/img/self-learn-v2/document-icon.svg" /><span>10
                Que’s</span></div>
    </div>
</ng-template>

<ng-template #SLV2Accuracycunt>
    <div class="SLV2-accuracy-box">
        <div class="SLV2-acrcy-col">
            <h4 class="SLV2-accuracy-title">Accuracy <img src="selflearnv2-ui/assets/img/self-learn-v2/info-icon.svg" />
            </h4>
            <h3 class="SLV2-accuracy-number">30%</h3>
        </div>
        <div class="SLV2-acrcy-col">
            <h4 class="SLV2-accuracy-title">Attempts</h4>
            <h3 class="SLV2-accuracy-number">01</h3>
        </div>
    </div>
</ng-template>